import { render, staticRenderFns } from "./DigitalTwin.vue?vue&type=template&id=80dfc1c4&scoped=true&"
import script from "./DigitalTwin.vue?vue&type=script&lang=js&"
export * from "./DigitalTwin.vue?vue&type=script&lang=js&"
import style0 from "./DigitalTwin.vue?vue&type=style&index=0&id=80dfc1c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80dfc1c4",
  null
  
)

export default component.exports